import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import { useState, useEffect } from 'react';
import { FormControl, InputLabel, MenuItem, Select, Alert } from '@mui/material';
import { AddAuthenticationModalProps, Authentication } from './types';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};



const AddAuthenticationModal: React.FC<AddAuthenticationModalProps> = ({ open, handleClose, handleSubmit, selectedData }) => {
    const [id, setId] = useState<number | null>(null);
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [authRole, setAuthRole] = useState('ADMIN');
    const [isLocked, setIsLocked] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (selectedData) {
            setId(selectedData.id);
            setUserName(selectedData.userName);
            setPassword('');
            setConfirmPassword('');
            setAuthRole(selectedData.authRole);
            setIsLocked(selectedData.isLocked);
            setIsActive(selectedData.isActive);
        }
        return () => {
            clearFields();
        };
    }, [selectedData]);

    const clearFields = () => {
        setId(null);
        setUserName('');
        setPassword('');
        setConfirmPassword('');
        setAuthRole('ADMIN');
        setIsLocked(false);
        setIsActive(true);
        setError(null);
    };

    const handleFormSubmit = (event: React.FormEvent) => {
        event.preventDefault();

        if (password !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        const data: Authentication = {
            id: id,
            userName,
            password,
            authRole,
            isLocked,
            isActive,
        };

        handleSubmit(data);
        handleClose();
        clearFields();
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    {selectedData ? 'Edit Authentication' : 'Add Authentication'}
                </Typography>
                <form onSubmit={handleFormSubmit}>
                    <TextField
                        autoComplete='off'
                        fullWidth
                        margin="normal"
                        label="Username"
                        variant="outlined"
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                    />
                    <FormControl fullWidth margin="normal" variant="outlined">
                        <InputLabel>Role</InputLabel>
                        <Select
                            value={authRole}
                            onChange={(e) => setAuthRole(e.target.value as string)}
                            label="Role"
                        >
                            <MenuItem value="ADMIN">Admin</MenuItem>
                            <MenuItem value="READ_ONLY">Read Only</MenuItem>
                            <MenuItem value="RESELLER">Reseller</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField
                        fullWidth
                        autoComplete='off'
                        margin="normal"
                        label="Password"
                        variant="outlined"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <TextField
                        fullWidth
                        autoComplete='off'
                        margin="normal"
                        label="Confirm Password"
                        variant="outlined"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}
                    <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
                        Submit
                    </Button>
                </form>
            </Box>
        </Modal>
    );
};

export default AddAuthenticationModal;
